module.exports = __webpack_public_path__ + "fonts/VWHeadWeb-Bold.e607f34b.woff2";